export const auth0Domain = process.env.AUTH0_DOMAIN;
export const auth0audience = process.env.AUTH0_AUDIENCE;
export const brandAuth0ClientId = process.env.AUTH0_CONFIG_CLIENT_ID_BRAND;
export const creatorAuth0ClientId = process.env.AUTH0_CONFIG_CLIENT_ID_CREATOR;
export const display_instagram_comments = process.env.ENABLE_INSTAGRAM_COMMENTS;
export const auth0FbCreatorScope = process.env.AUTH0_FB_CREATOR_SCOPE;
export const auth0CreatorsProfileRedirectUrl = process.env.AUTH0_CREATORS_PROFILE_REDIRECT_URL;
export const display_upload_additional_documents = true;
export const display_upload_video_content = true;
// eslint-disable-next-line max-len
export const facebookCreatorAuthUrl = `https://${auth0Domain}/authorize?response_type=id_token&scope=openid%20profile%20pages_show_list&client_id=${creatorAuth0ClientId}&redirect_uri=${auth0CreatorsProfileRedirectUrl}/creator/dashboard/profile&connection=facebook&connection_scope=${auth0FbCreatorScope}&nonce=`;
export const filestack_api_key = process.env.FILESTACK_API_KEY;
export const filestack_api_url = process.env.FILESTACK_API_URL;
export const filestack_upload_container = process.env.S3_BUCKET;
export const graphqlGatewayUrl = process.env.GRAPHQL_GATEWAY_URL;
export const isRateCreatorsDisabled = process.env.RATE_CREATORS;
export const launchdarkly_client_id = process.env.LAUNCHDARKLY_ENVIRONMENT_KEY;
export const socialConnectionAppClient = process.env.SOCIAL_CONNECTION_APP_CLIENT_ID;
export const socialConnectionAppClientSecret = process.env.SOCIAL_CONNECTION_APP_CLIENT_SECRET;
export const socialConnectionAppUrl = process.env.SOCIAL_CONNECTION_APP_URL;
export const featureFlags = {
    isPinterestEnabled: true,
    smartQuestionsUpdate: true,
    newCreatorSignUpFlowEnabled: JSON.parse(process.env.NEW_CREATOR_SIGN_UP_FLOW_ENABLED || 'false')
};
export const filestack = {
    url: filestack_api_url,
    key: filestack_api_key,
    container: filestack_upload_container
};



// WEBPACK FOOTER //
// ./environmentHelper.js